export const AllReasonCodes:any = {
  MASTERCARD: [
    {
      ReasonCode: "4840",
      ReasonCodeDescription: "Fraudulent Processing of Transactions",
    },
    {
      ReasonCode: "4849",
      ReasonCodeDescription: "Questionable merchant activity",
    },
    {
      ReasonCode: "4870",
      ReasonCodeDescription: "Chip Liability Shift",
    },
    {
      ReasonCode: "4871",
      ReasonCodeDescription: "Chip/PIN Liability Shift",
    },
    {
      ReasonCode: "4999",
      ReasonCodeDescription: "Domestic Chargeback Dispute (Europe region only)",
    },
    {
      ReasonCode: "4835",
      ReasonCodeDescription: "Card Not Valid or Expired",
    },
    {
      ReasonCode: "4807",
      ReasonCodeDescription: "Warning Bulletin File",
    },
    {
      ReasonCode: "4808",
      ReasonCodeDescription: "Requested Required Authorization not obtained",
    },
    {
      ReasonCode: "4812",
      ReasonCodeDescription: "Account Number Not on File",
    },
    {
      ReasonCode: "4834",
      ReasonCodeDescription: "Point of Interaction (POI) Error",
    },
    {
      ReasonCode: "4831",
      ReasonCodeDescription: "Transaction amount differs",
    },
    {
      ReasonCode: "4842",
      ReasonCodeDescription: "Late Presentment",
    },
    {
      ReasonCode: "4846",
      ReasonCodeDescription: "Correct Transaction Currency Code not provided",
    },
    {
      ReasonCode: "4850",
      ReasonCodeDescription: "Credit Posted as a Purchase",
    },
    {
      ReasonCode: "4853",
      ReasonCodeDescription: "Cardholder Dispute",
    },
    {
      ReasonCode: "4841",
      ReasonCodeDescription: "Cancelled Recurring Transaction",
    },
    {
      ReasonCode: "4854",
      ReasonCodeDescription: "Not Elsewhere Classified (U.S. region only)",
    },
    {
      ReasonCode: "4855",
      ReasonCodeDescription: "Non receipt of merchandise",
    },
    {
      ReasonCode: "4860",
      ReasonCodeDescription: "Credit not Processed",
    },
    {
      ReasonCode: "6305",
      ReasonCodeDescription: "Cardholder does not agree with amount billed",
    },
    {
      ReasonCode: "5",
      ReasonCodeDescription:
        "Cardholder Dispute - Card Holder Does Not Agree with Amount Billed",
    },
    {
      ReasonCode: "21",
      ReasonCodeDescription: "Unrecognized Transaction",
    },
    {
      ReasonCode: "22",
      ReasonCodeDescription: "Cardholder Inquiry - Disagrees With Billing",
    },
    {
      ReasonCode: "23",
      ReasonCodeDescription: "Cardholder Requires Proof for Personal Records",
    },
    {
      ReasonCode: "24",
      ReasonCodeDescription: "Cardholder Inquiry - No Reason Code",
    },
    {
      ReasonCode: "42",
      ReasonCodeDescription: "Potential Chargeback or Compliance Documentation",
    },
    {
      ReasonCode: "43",
      ReasonCodeDescription: "Legal/Fraud - Imprint Verification",
    },
    {
      ReasonCode: "4837",
      ReasonCodeDescription: "No Cardholder Authorization",
    },
    {
      ReasonCode: "4863",
      ReasonCodeDescription: "Cardholder does not recognize Potential Fraud",
    },
    {
      ReasonCode: "41",
      ReasonCodeDescription:
        "Signature Verification - Required for Legal/Fraud Investigation",
    },
  ],
  VISA: [
    {
      ReasonCode: "10.1",
      ReasonCodeDescription: "EMV Liability Shift Counterfeit Fraud",
    },
    {
      ReasonCode: "10.2",
      ReasonCodeDescription: "EMV Liability Shift Non-Counterfeit Fraud",
    },
    {
      ReasonCode: "10.3",
      ReasonCodeDescription: "Other Fraud-Card Present Environment",
    },
    {
      ReasonCode: "10.4",
      ReasonCodeDescription: "Other Fraud-Card Absent Environment",
    },
    {
      ReasonCode: "10.5",
      ReasonCodeDescription: "Visa Fraud Monitoring Program",
    },
    {
      ReasonCode: "11.1",
      ReasonCodeDescription: "Card Recovery Bulletin",
    },
    {
      ReasonCode: "11.2",
      ReasonCodeDescription: "Declined Authorization",
    },
    {
      ReasonCode: "11.3",
      ReasonCodeDescription: "No Authorization",
    },
    {
      ReasonCode: "12.1",
      ReasonCodeDescription: "Late Presentment",
    },
    {
      ReasonCode: "12.2",
      ReasonCodeDescription: "Incorrect Transaction Code / Processing Code",
    },
    {
      ReasonCode: "12.3",
      ReasonCodeDescription: "Incorrect Currency",
    },
    {
      ReasonCode: "12.4",
      ReasonCodeDescription: "Incorrect Account Number",
    },
    {
      ReasonCode: "12.5",
      ReasonCodeDescription: "Incorrect Amount",
    },
    {
      ReasonCode: "12.6",
      ReasonCodeDescription: "Duplicate Processing/Paid by Other Means",
    },
    {
      ReasonCode: "12.7",
      ReasonCodeDescription: "Invalid Data",
    },
    {
      ReasonCode: "13.1",
      ReasonCodeDescription: "Merchandise/Services Not Received",
    },
    {
      ReasonCode: "13.2",
      ReasonCodeDescription: "Canceled Recurring",
    },
    {
      ReasonCode: "13.3",
      ReasonCodeDescription:
        "Not as Described or Defective Merchandise/Services",
    },
    {
      ReasonCode: "13.4",
      ReasonCodeDescription: "Counterfeit Merchandise",
    },
    {
      ReasonCode: "13.5",
      ReasonCodeDescription: "Misrepresentation",
    },
    {
      ReasonCode: "13.6",
      ReasonCodeDescription: "Credit not Processed",
    },
    {
      ReasonCode: "13.7",
      ReasonCodeDescription: "Canceled Merchandise/Services",
    },
    {
      ReasonCode: "13.8",
      ReasonCodeDescription: "Original Credit Transaction Not Accepted",
    },
    {
      ReasonCode: "28",
      ReasonCodeDescription: "Cardholder Requests Copy Bearing Signature",
    },
    {
      ReasonCode: "29",
      ReasonCodeDescription: "Request for T&E Documents",
    },
    {
      ReasonCode: "30",
      ReasonCodeDescription: "Cardholder Dispute, Cardholder Request Draft",
    },
    {
      ReasonCode: "33",
      ReasonCodeDescription: "Legal Process or Fraud Analysis",
    },
    {
      ReasonCode: "34",
      ReasonCodeDescription: "Repeat Request for Cop",
    },
  ],
  AMEX: [
    {
      ReasonCode: "4540",
      ReasonCodeDescription: "Card Not Present (fraud)",
    },
    {
      ReasonCode: "4763",
      ReasonCodeDescription: "Full recourse",
    },
    {
      ReasonCode: "4534",
      ReasonCodeDescription: "No Card Member Authorization",
    },
    {
      ReasonCode: "4521",
      ReasonCodeDescription: "No Valid Authorization",
    },
    {
      ReasonCode: "4751",
      ReasonCodeDescription: "Expired Authorization",
    },
    {
      ReasonCode: "4507",
      ReasonCodeDescription: "Incorrect Transaction Amount Presented",
    },
    {
      ReasonCode: "4512",
      ReasonCodeDescription: "Multiple Processing",
    },
    {
      ReasonCode: "4522",
      ReasonCodeDescription: "Authorization Declined",
    },
    {
      ReasonCode: "4523",
      ReasonCodeDescription: "Unassigned C/M Account Number",
    },
    {
      ReasonCode: "4525",
      ReasonCodeDescription: "Transaction Amount Changed",
    },
    {
      ReasonCode: "4530",
      ReasonCodeDescription: "Currency Discrepancy",
    },
    {
      ReasonCode: "4536",
      ReasonCodeDescription: "Late Presentment",
    },
    {
      ReasonCode: "4752",
      ReasonCodeDescription: "Credit/Debit Presentment Error",
    },
    {
      ReasonCode: "4755",
      ReasonCodeDescription: "No Valid Approval Code",
    },
    {
      ReasonCode: "4758",
      ReasonCodeDescription: "Expired/Not Yet valid card",
    },
    {
      ReasonCode: "4515",
      ReasonCodeDescription: "Paid through Other Means",
    },
    {
      ReasonCode: "4532",
      ReasonCodeDescription: "Damaged and/or Defective Goods/Services",
    },
    {
      ReasonCode: "4544",
      ReasonCodeDescription: "Cancelation of Recurring Goods/Services services",
    },
    {
      ReasonCode: "4554",
      ReasonCodeDescription: "Goods and Services Not Received",
    },
    {
      ReasonCode: "4754",
      ReasonCodeDescription: "Local Regulatory/Legal Dispute",
    },
    {
      ReasonCode: "6003",
      ReasonCodeDescription: "Chargeback Documentation",
    },
    {
      ReasonCode: "6006",
      ReasonCodeDescription: "Legal Request or Fraud Analysis",
    },
    {
      ReasonCode: "6008",
      ReasonCodeDescription:
        "Card Member requests copy bearing signature (signed support)",
    },
    {
      ReasonCode: "6013",
      ReasonCodeDescription: "Repeat Documentation Request",
    },
    {
      ReasonCode: "4798",
      ReasonCodeDescription: "Fraud Liability Shift Counterfeit",
    },
    {
      ReasonCode: "4799",
      ReasonCodeDescription: "Fraud Liability Shift Lost/Stolen/Non-Received",
    },
    {
      ReasonCode: "6014",
      ReasonCodeDescription:
        "Card Member does not recognise Transaction or Transaction Amount",
    },
    {
      ReasonCode: "6016",
      ReasonCodeDescription: "Card member needs for personal records",
    },
    {
      ReasonCode: "4513",
      ReasonCodeDescription: "Credit Not Presented",
    },
    {
      ReasonCode: "4516",
      ReasonCodeDescription: "Request For Support Not Fulfilled",
    },
    {
      ReasonCode: "4517",
      ReasonCodeDescription: "Request For Support Illegible / Incomplete",
    },
    {
      ReasonCode: "4527",
      ReasonCodeDescription: "Missing Imprint",
    },
    {
      ReasonCode: "4553",
      ReasonCodeDescription: "Not As Described Or Defective Merchandise",
    },
    {
      ReasonCode: "4750",
      ReasonCodeDescription:
        "Car Rental Charge Non Qualified or Unsubstantiated",
    },
  ],
  JCB: [
    {
      ReasonCode: "0002",
      ReasonCodeDescription: "Required for corporate card accounting",
    },
    {
      ReasonCode: "0003",
      ReasonCodeDescription: "Required for legal process",
    },
    {
      ReasonCode: "0004",
      ReasonCodeDescription: "Lost card, fraud investigation",
    },
    {
      ReasonCode: "0005",
      ReasonCodeDescription: "Cardmember does not recognize sale",
    },
    {
      ReasonCode: "0006",
      ReasonCodeDescription: "Cardmember claims amount incorrect",
    },
    {
      ReasonCode: "0000",
      ReasonCodeDescription: "Other",
    },
    {
      ReasonCode: "0001",
      ReasonCodeDescription: "Signature confirmation",
    },
    {
      ReasonCode: "0583",
      ReasonCodeDescription: "Paid by Other Means",
    },
    {
      ReasonCode: "0502",
      ReasonCodeDescription: "Cardmember Dispute",
    },
    {
      ReasonCode: "0513",
      ReasonCodeDescription: "Credit Not Received",
    },
    {
      ReasonCode: "0516",
      ReasonCodeDescription: "Non-Receipt of Requested Item",
    },
    {
      ReasonCode: "0544",
      ReasonCodeDescription: "Canceled Recurring Transaction",
    },
    {
      ReasonCode: "0554",
      ReasonCodeDescription:
        "Non-Receipt of Merchandise/Non-Receipt of Cash at ATM",
    },
    {
      ReasonCode: "0537",
      ReasonCodeDescription: "No show dispute",
    },
    {
      ReasonCode: "0538",
      ReasonCodeDescription: "Advance Deposit",
    },
    {
      ReasonCode: "0534",
      ReasonCodeDescription: "Unauthorized Multiple Transaction",
    },
    {
      ReasonCode: "0546",
      ReasonCodeDescription: "Unauthorized Purchase",
    },
    {
      ReasonCode: "0526",
      ReasonCodeDescription: "No Signature",
    },
    {
      ReasonCode: "0527",
      ReasonCodeDescription: "No Imprint",
    },
    {
      ReasonCode: "0517",
      ReasonCodeDescription: "Requested Copy Illegible",
    },
    {
      ReasonCode: "0522",
      ReasonCodeDescription: "Authorization Declined",
    },
    {
      ReasonCode: "0523",
      ReasonCodeDescription: "Incorrect Card number",
    },
    {
      ReasonCode: "0503",
      ReasonCodeDescription: "Expired JCB Card",
    },
    {
      ReasonCode: "0547",
      ReasonCodeDescription: "Card on Stop List",
    },
    {
      ReasonCode: "0507",
      ReasonCodeDescription: "Incorrect Transaction Amount",
    },
    {
      ReasonCode: "0510",
      ReasonCodeDescription: "Mispost",
    },
    {
      ReasonCode: "0512",
      ReasonCodeDescription: "Duplicate Processing",
    },
    {
      ReasonCode: "0524",
      ReasonCodeDescription: "Addition Error",
    },
    {
      ReasonCode: "0525",
      ReasonCodeDescription: "Altered Amount",
    },
    {
      ReasonCode: "0536",
      ReasonCodeDescription: "Late Submission",
    },
    {
      ReasonCode: "0541",
      ReasonCodeDescription: "Illegible Item",
    },
    {
      ReasonCode: "0581",
      ReasonCodeDescription: "Split Sale",
    },
  ],
};
